var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5 6.80929L17.1907 5.5L12 10.6907L6.80929 5.5L5.5 6.80929L10.6907 12L5.5 17.1907L6.80929 18.5L12 13.3093L17.1907 18.5L18.5 17.1907L13.3093 12L18.5 6.80929Z",
    fill: "#C6CCFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIdea);
export default __webpack_public_path__ + "static/media/remove-idea.e50870745589facbfdd10c26c7d4a9e7.svg";
export { ForwardRef as ReactComponent };